import { Suspense, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getDirection } from '@/i18n/config'
import { Toaster } from '@/components/ui/sonner'
import { LoadingScreen } from '@/components/ui/spinner'
import AppInitializerGate from '@/components/app-initializer/gate'

export default function RootLayout() {
  const { i18n } = useTranslation()

  // 监听语言变化，更新 HTML 属性
  useEffect(() => {
    const currentLanguage = i18n.language
    const direction = getDirection(currentLanguage)
    document.documentElement.lang = currentLanguage
    document.documentElement.dir = direction
  }, [i18n.language])

  return (
    <AppInitializerGate>
      <Suspense fallback={<LoadingScreen bgClassName="bg-black/60" />}>
        <Outlet />
      </Suspense>
      <Toaster />
    </AppInitializerGate>
  )
}
